<template>
  <!-- 通用线型数据排行榜3-显示两个数据组 [100/50/20/30]/200这种方式 ,表示一个数据的多种状态组成，比如打卡总人数200，正常100+异常100-->
  <div class="item-rank">
    <yq-empty description="暂无数据" v-if="itemCount.length === 0" style="padding: 0"/>
    <div class="rank-item" v-else>
      <div class="rank-item-name">
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">{{item.itemName}}</div>
      </div>
      <div class="rank-item-percent" >
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">
          <div class="percent-background">
            <div v-for="(it, idx) in item.dataArr" :key="idx" class="percent" :style="{'width': it.percent + '%', backgroundColor: colorList[idx % colorList.length]}"></div>
          </div>
        </div>
      </div>
      <div class="rank-item-count">
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">
          <span class="count-warning">
            [<span v-for="(it, idx) in item.dataArr" :key="idx"><span v-if="idx !== 0">,</span><span>{{it.count}}</span></span>]
          </span>
          <span>/</span>
          <span>{{item.allCount}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";

export default {
  props: {
    dataList: {
      default: () => [
        {itemName: "绿城.桃源小镇一期", listCount: [100,150], allCount: 200},
        {itemName: "江南一号", listCount: [100,200,0,0], allCount: 300},
        {itemName: "绿城.明月江南", listCount: [90,60,20,30], allCount: 200},
        {itemName: "绿城.锦绣风华", listCount: [120,30,20,30], allCount: 200},
        {itemName: "绿城.春江花月", listCount: [50,100,20,30], allCount: 200},
      ]
    },
    colorList: {
      default: () => ["#38d7ff","#38ff6d","#4599ff","#9e66ff","#f94aff"]
    }
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SimpleRank2",
  components: {
  },
  data() {
    return {
      itemCount: [
        {dataArr: [{count: 98, percent: 99}, {count: 3, percent: 1} ], allCount: 102, itemName: "打卡设备"},
        {dataArr: [{count: 44, percent: 50}, {count: 44, percent: 50} ], allCount: 80, itemName: "视频设备"},
        {dataArr: [{count: 98, percent: 57}, {count: 82, percent: 43} ], allCount: 180, itemName: "无人机"},
      ],
    };
  },
  created() {
    this.init();
    watch(() => this.dataList, () => {this.init()})
  },
  methods: {
    init() {
      this.itemCount = [...this.dataList];
      // 计算比例
      this.itemCount.forEach(item => {
        if (!item.allCount || item.allCount === 0) {
          item.listCount = [];
          return;
        }
        let arr = [];
        for (let i = 0; i < item.listCount.length; i++) {
          arr.push({count: item.listCount[i], percent: item.listCount[i] / item.allCount * 100}) // 数量和百分比
        }
        item.dataArr = arr;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.item-rank{
  .rank-count{
    margin-bottom: 20px;
  }
  .rank-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-bottom: 10px;
    .rank-data{
      height: 30px;
      line-height: 30px;
    }
    .rank-item-name{
      >div{
        white-space: nowrap;
      }
    }
    .rank-item-percent{
      width: 100px;
      flex: 1;
      box-sizing: border-box;
      padding: 0 20px;
      overflow: hidden;
      .rank-data{
        display: flex;
        align-items: center;
      }
      .percent-background{
        height: 5px;
        border-radius: 8px;
        background: var(--yq-background-color);
        width: 100%;
        display: flex;
        .percent{
          height: 5px;
          border-radius: 8px;
        }
      }

    }
    .rank-item-count{
      >div{
        white-space: nowrap;
      }
      .count-warning{
        color: var(--map-color-warn);
      }
    }
  }
}
</style>